export default __webpack_public_path__ + "static/media/LIGHT_HISTORY.42c5ae24.svg";